/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolShoppingCartIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-shopping-cart"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M6.55 22.5Q6.55 22.5 6.08 22.5Q5.6 22.5 4.92 21.82Q4.25 21.15 4.25 20.2Q4.25 19.25 4.92 18.57Q5.6 17.9 6.55 17.9Q7.5 17.9 8.18 18.57Q8.85 19.25 8.85 20.2Q8.85 21.15 8.18 21.82Q7.5 22.5 6.55 22.5ZM17.15 22.5Q17.15 22.5 16.68 22.5Q16.2 22.5 15.53 21.82Q14.85 21.15 14.85 20.2Q14.85 19.25 15.53 18.57Q16.2 17.9 17.15 17.9Q18.1 17.9 18.77 18.57Q19.45 19.25 19.45 20.2Q19.45 21.15 18.77 21.82Q18.1 22.5 17.15 22.5ZM4.8 3.3L20.9 3.3Q21.48 3.3 21.76 3.81Q22.05 4.33 21.75 4.85L17.7 12.1Q17.4 12.68 16.85 13.01Q16.3 13.35 15.65 13.35L7.9 13.35L7.1 14.75Q7.1 14.75 7.1 14.75Q7.1 14.75 7.1 14.75L18.18 14.75Q18.73 14.75 19.11 15.14Q19.5 15.53 19.5 16.07Q19.5 16.63 19.11 17.01Q18.73 17.4 18.18 17.4L6.55 17.4Q5.22 17.4 4.59 16.24Q3.95 15.07 4.55 13.95L5.8 11.6L2.2 3.95L1.38 3.95Q0.82 3.95 0.44 3.56Q0.05 3.17 0.05 2.63Q0.05 2.08 0.44 1.69Q0.82 1.3 1.38 1.3L3 1.3Q3.38 1.3 3.7 1.5Q4.03 1.7 4.2 2.05Z" fill={color} />
    </svg>
  );
}
